@if (dataState.isLoading()) {
  <mat-progress-bar
    class="tasks-progress"
    mode="indeterminate"
    [dataSelector]="'cxp-tasks-loading-bar'"
  ></mat-progress-bar>
}

<div class="tasks-grid">
  <section class="tasks-sidebar tasks-sidebar-left">
    <div class="tasks-filters-header">
      <span class="h4-500 color-gray-100 py-1">Filters</span>
      
      @if (hasSelectedFilters()) {
        <button
          andButton
          color="ghost-secondary"
          size="small"
          [showMenuIcon]="false"
          [dataSelector]="'cxp-tasks-clear-all-filters'"
          (click)="onClearAllFilters()"
        >
          Clear All
        </button>
      }
    </div>

    <cxp-task-filters-sidebar
      [filterGroups]="filterGroups()"
      [selectedFilters]="selectedFilters()"
      (filterChanged)="onFilterChanged($event)"
    />
  </section>

  <section class="tasks-main">
    <span class="tasks-main-title body-300">Requests</span>
    
    <cxp-task-list
      [tasks]="displayedTasks()"
      [tabs]="tabOptions()"
      [activeTab]="activeTab()"
      [searchQuery]="searchQuery()"
      [isLoading]="dataState.isLoading()"
      (tabChanged)="onTabChanged($event)"
      (taskSelected)="onTaskSelected($event)"
      (searchQueryChanged)="onSearchQueryChanged($event)"
    />
  </section>

  <section class="tasks-sidebar tasks-sidebar-right">
    <cxp-task-staff-sidebar [staff]="dataState.staff()" />
  </section>
</div>
